import React, { Suspense, useEffect, useReducer, useState } from 'react';
import HandleRoutesPath from './router/routeIndex';
import { MessageContext, messageReducer, initState } from './store/messageStore';
import Message from './components/Message';
import { initLoad, loadReducer, SystemLoading } from './store/loadingStore';
import SystemLoad from './components/SystemLoad';
import { userReducer,initUserState,AcctContext } from './utility/useReduce/userNameReduce';
//icons  
import "primeicons/primeicons.css";            
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { faTwitter, faFontAwesome } from '@fortawesome/free-brands-svg-icons'


//custom style 請放在最下方
import './assets/styles/styles.scss'; 
import { initDataProp } from './utility/service/api-service';
import { checkDpSuccess } from './utility/service/tool-service';
import AiLexiHelper from './components/AiLexiHelper';
import usePrimeDropdownImeFix from './utility/hook/usePrimeDropdownImeFix';

library.add(fas, far, faTwitter, faFontAwesome)

function App() {
  const reducer = useReducer(messageReducer, initState); //訊息視窗 
  const load = useReducer(loadReducer, initLoad);
  const userNameReducer = useReducer(userReducer,initUserState)
  const [showAi,setShowAi] = useState(false);
  const [helloWord,setHelloWrod] = useState([]);
  const [helperPopup,setHelperPopup] = useState([]);//default message
  const [helperTips,setHelperTips] = useState([]);//default tips
  //全域修正中文輸入方向鍵與 Enter 問題 Dropdown filter輸入
  // Global fix for Chinese input arrow & Enter key issues in Dropdown filter
  usePrimeDropdownImeFix(); 

  const axios_initDataProp = ()=>{
    initDataProp({reqType:'aiChat'})
      .then((res)=>{
        if(checkDpSuccess(res)){
          let data = res?.data?.RespBody;
          let aiChat = data?.helperFlag==='true'?true:false;
          if(data?.helperMsgList){
            setHelloWrod(data?.helperMsgList);
          }
          if(data?.helperPopupList){
            setHelperPopup(data?.helperPopupList);
          }
          if(data?.helperTipsList){
            setHelperTips(data?.helperTipsList);
          }
          setShowAi(aiChat)
        }
        
      })
  }

  useEffect(()=>{
    const loadCSS = ()=>{
      try {
        let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `${process.env.PUBLIC_URL}/styles/theme_${themeColorSession}.css`;
        document.head.appendChild(link);

        return () => {
          document.head.removeChild(link);
        }

      } catch (error) {
        
      }
    }
    loadCSS();
    axios_initDataProp();
  },[])

  return (
   <>
     <MessageContext.Provider value={reducer}>
        <SystemLoading.Provider value={load}>
          <AcctContext.Provider value={userNameReducer}>
          <Suspense>
              <Message />
              <SystemLoad />
              <HandleRoutesPath>
             
              </HandleRoutesPath>
          </Suspense>
          </AcctContext.Provider>
        </SystemLoading.Provider>
      </MessageContext.Provider>
      {
        showAi && <AiLexiHelper helperMsgList={helloWord} helperPopupList={helperPopup} helperTipsList={helperTips} />
       }
   </>
  );
}

export default App;
